import { ReactNode } from "react";

import { IgPaper, IgSelect, IgTypography } from "@intelligems/ig-theme";
import { Box, MenuItem, Stack, useTheme } from "@mui/material";

interface DropdownOption {
  title: string | string[];
  id: string;
}

interface MobileAnalyticsFrameProps {
  title: string;
  selectedValue: string;
  onSelectionChange: (value: string) => void;
  dropdownOptions: DropdownOption[];
  children: ReactNode;
}

export const MobileAnalyticsFrame = ({
  title,
  selectedValue,
  onSelectionChange,
  dropdownOptions,
  children,
}: MobileAnalyticsFrameProps) => {
  return (
    <>
      <Stack
        justifyContent="space-between"
        alignItems="center"
        direction="row"
        flexShrink={0}
        gap={2}
        sx={{ overflow: "hidden" }}
      >
        <IgTypography variant="h3" fontWeight={600} sx={{ flexShrink: 0 }}>
          {title}
        </IgTypography>
        <Box sx={{ minWidth: 0, maxWidth: "300px" }}>
          <IgSelect
            fullWidth
            sx={{
              "& .MuiSelect-select": {
                paddingX: 4,
                paddingY: 2,
                marginRight: 4,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                display: "block",
              },
            }}
            value={selectedValue}
            onChange={(e) => {
              onSelectionChange(e.target.value);
            }}
          >
            {dropdownOptions.map((option) => (
              <MenuItem key={option.id} value={option.id}>
                <IgTypography>
                  {Array.isArray(option.title)
                    ? option.title.join(" ")
                    : option.title}
                </IgTypography>
              </MenuItem>
            ))}
          </IgSelect>
        </Box>
      </Stack>
      <IgPaper sx={{ padding: "24px" }}>
        <Stack spacing={2}>{children}</Stack>
      </IgPaper>
    </>
  );
};
